import { $delegate, $qs } from 'fxdom/es';
import { find, go } from 'fxjs/es';
import { MuiF } from '../../../../Mui/F/Function/module/MuiF.js';
import { UtilF } from '../../../../Util/F/Function/module/UtilF.js';
import { NewMakerCheckConditionConstantS } from '../../../CheckCondition/S/Constant/module/NewMakerCheckConditionConstantS.js';
import { NewMakerConditionTooltipMoMuiF } from '../Mui/module/NewMakerConditionTooltipMoMuiF.js';
import { getAgreeTextData } from '@modules/NewMaker/ConditionAgreeText/F/Function/conditionagreetext.js';
import { ConfigSentryF } from '@modules/Config/Sentry/F/Function/module/ConfigSentryF.js';
import { NewMakerConditionAgreeTextF } from '@modules/NewMaker/ConditionAgreeText/F/Function/module/NewMakerConditionAgreeTextF.js';
let is_error = false;
export const open = async () => {
  const popup_data = go(
    getAgreeTextData(null, true),
    find(
      (popup) =>
        popup.type === NewMakerCheckConditionConstantS.CONFIRM_POPUP_ANY_CORNER_OUT_BOUNDS_FULL_FILL_TYPE,
    ),
  );

  const is_mobile = UtilF.isLegacyMobile();
  if (!is_mobile) throw new Error('pc frame 없음');
  setTimeout(() => {
    if (is_error) return;
    const frame = $qs('.don_frame[frame_name="/modules/NewMaker/ConditionTooltipMo/S/Mui/frame.js"]');
    if (!frame) {
      open();
    }
  }, 100);

  return new Promise((resolve) => {
    return MuiF.openFrame(NewMakerConditionTooltipMoMuiF.frame, async (frame, page, [tab]) => {
      try {
        frame.title = G.collabo_type === 'creator' ? TT('maker::tooltip::mo_title') : '';
        frame.prev_frame_show = is_mobile;
        frame.is_modal = !is_mobile;
        const tooltip = popup_data ? popup_data[`tooltip${G._en}`] : null;
        frame.closed = ($frame, val) => {
          resolve(val);
        };

        tab.makeData = () => {
          return {
            tooltip,
          };
        };
        await MuiF.makeFrameHeight(frame, tab, true);
      } catch (e) {
        is_error = true;
        ConfigSentryF.criticalError(e);
        frame.title = G.collabo_type === 'creator' ? TT('maker::tooltip::mo_title') : '';
        frame.prev_frame_show = is_mobile;
        frame.is_modal = !is_mobile;
        const text_height = 22;
        const tooltip = popup_data ? popup_data[`tooltip${G._en}`] : null;
        if (G.collabo_type === 'creator') {
          frame.height = 505 + NewMakerConditionAgreeTextF.agreeTextCount() * 38;
        } else {
          frame.height =
            (tooltip ? 500 : 195) +
            G.mp.frame.v_height +
            NewMakerConditionAgreeTextF.agreeTextCount() * text_height;
        }
        frame.closed = ($frame, val) => {
          resolve(val);
        };

        tab.makeData = () => {
          return {
            tooltip,
          };
        };
      }
    });
  });
};

export const halfFrameClose = (frame_el$) => {
  go(
    frame_el$,
    $delegate('click', '>.don_wrapper >.header', (e) => {
      MuiF.removeFrame();
    }),
  );
};
